import RecipientSelectField from './RecipientSelectField';

export default RecipientSelectField;
